import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, {
  SelectProductWithError,
} from "../../../../Components/Utils/Select";
import {
  NuDate,
  NuInput,
  NuInputWithError,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import DropDownAddMetaData, {
  DropDownAddUnitWithError,
} from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import CloseIcon from "../../../../Components/Icons/Close";
import Video from "../../../../Components/Icons/Video";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import { useToast } from "../../../../Components/Others/ToastServices";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import MultiSelect, {
  MultiSelectinp,
} from "../../../../Components/Utils/MultiSelect";
import axiosInstance from "../../../../Services/axiosCommon";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import { Select } from "antd";
import { EditIcon } from "lucide-react";
import UseEqupiProductDropDownNew from "../../../../Components/Hooks/useEqupiProductDropDown";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import DeleteIcon from "../../../../Components/Icons/Delete";

function EditSurveyReport() {
  const [searchClient, setSearchClient] = useState("");
  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [image, setImage] = useState([]);
  const toast = useToast();
  const [isEquipmentEditable, setIsEquipmentEditable] = useState(false);
  const [oldData, setOldData] = useState([]);
  const [sortedProList, setSortedProList] = useState([]);
  const [Equipitems, setEquipItems] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
const [deleteInfo, setDeleteInfo] = useState(null); 
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );
  const { data: inspector, setDataInspector } = UseInspectorDD(
    "/inspectors/drop-down",
    searchClient
  );
  const { value: status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Survey"
  );
  const [searchequipment, setSearchequipment] = useState("");

  const { data: Item, setData: setDataItem } = UseEqupiProductDropDownNew(
    "/equipments/drop-down",
    searchequipment
  );

  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );

  const [formAssignees, setFormAssignees] = useState([]);
  // const [Newinspector, setInspector] = useState([]);

  const { data: form } = UseDropDownNew(`/form/drop-down`);
  const { data: user } = UseDropDown(`/user/new-drop-down`);

  const { value: Equip, getData: refEquip } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Contract_Equip"
    );

  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  const from = location.state?.from;
  // const sData = location.state?.data;

  const [data, setData] = useState(null);
  const { surveyReportEditId } = useParams();
  const [removefilePathList, setRemoveFilePathList] = useState([]);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
  const navigate = useNavigate();
  // const data = location.state.data;

  const { editFormData, isLoading } = useEditFormData();
  const [createNew, setCreateNew] = useState([]);

  function getView() {
    axiosInstance
      .get(`/survey-report/getById/${surveyReportEditId}`)
      .then((res) => {
        res?.data?.data && setData(res?.data?.data);
        setCreateNew({
          clientId: res?.data?.data?.clientId || "",
          clientName: res?.data?.data?.clientName || "",
          clientRefNumber: res?.data?.data?.clientRefNumber || "",
          inspectionDate: res?.data?.data?.inspectionDate || "",
          location: res?.data?.data?.location || "",
          project: res?.data?.data?.project || "",
          scope: res?.data?.data?.scope || "",
          refNumber: res?.data?.data?.refNumber || "",

          status: res?.data?.data?.status || "",
          form: res?.data?.data?.form || "",


          assignee:res?.data?.data?.assignee?.map((item) => Number(item.assignee)) ||[],
          filesToRemove: [],
          attachments: res?.data?.data?.attachments || [],
          equipments: res?.data?.data?.equipments || []  ,


        });

        // if (res.data.data.assignee) {
        //   formik.setFieldValue(
        //     "assignee",
        //     res.data.data.assignee.map(item => Number(item.assignee))
        //   );
        // }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!sData) {
    getView();
    // }
  }, []);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      clientId: yup.string().required("Client is required!"),
      // inspector: yup
      //   .string()
      //   .required("Inspector is required!"),
    //   assignee: yup
    //     .array()
    //     .of(yup.number())
    //     .min(1, "Assignee is required!")
    //     .required("Assignee is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {

  //         const isNewEmpty = Equipitems.length === 0;
  // const isExistingEmpty = !createNew?.Equipitems || createNew.Equipitems.length === 0;

  // if (Equipitems.length === 0 && !createNew?.equipments) {
  //   setEquipmentError("Equipment table is empty!");
  //   return;
  // }


      let formData = new FormData();
    const valueWithItems = {
  ...value,
  filesToRemove: fileRemoveList,
  equipments: [...(createNew?.equipments || []), ...(Equipitems || []),
  ],
};
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await editFormData({
        url: `/survey-report/update_survey-report/${surveyReportEditId}`,
        formData: formData,
        navigateUrl: from || `/Contract-management/survey-report`,
        resetForm: resetForm,
      });

      // editFormData(
      //   `/survey-report/update_survey-report/${surveyReportEditId}`,
      //   formData,
      //   resetForm,
      //   from,
      // );
    },
  });

   const [showPopupCat, setShowPopupCat] = useState(false);
  
    const togglePopupCat = () => {
      setShowPopupCat(!showPopupCat);
    };
  
    const resetFormCat = () => {
      formik.values.name = "";
     
  
      setShowPopupCat(false);
    };
  
    const handlePopupSubmitCat = async (e) => {
      e.preventDefault();
  
      
      try {
        const response = await axiosInstance.post(
          "/categories/new-category",
          { name: formik.values.name }
        );
        getContractsByClientId()
        const createdcat = response.data?.data;
  
        setData((prevCat) => [
          {
            label: formik.values.name || "-",
            value: createdcat,
          },
          ...prevCat,
        ]);
        resetFormCat();
      } catch (error) {
        console.error("Error creating new customer:", error);
      }
    };


    function getContractsByClientId(clientId) {
        axiosInstance
          .get(`/categories/`)
          .then((res) => {
           if (Array.isArray(res.data.data)) {
            const formatted = res.data.data.map(item => ({
              value: item.name,        
              label: item.name      
            }));
            setcat(formatted);
            } else {
              console.error("Unexpected API response format");
              setcat([]);
            }
          })
          .catch(err => {
            console.error("Error fetching contracts by client ID:", err);
            setcat([]);
          });
      }
    
      useEffect(() => {
         getContractsByClientId();
    
      }, [])


     function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      // console.log(data.attachments, "ghjkllgd");
      setFilePathList(data?.attachments);

      setRemoveFilePathList(data?.attachments || []);
    }
  }, [data]);
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }
  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

  const [value, setValue] = useState({
    equipEnabled: false,
    id: 1,
  });

  const handleToggleChange = (id) => {
    setValue((prevValue) => ({
      ...prevValue,
      equipEnabled: !prevValue.equipEnabled,
    }));
  };

  const [addEquipment, setAddEquipment] = useState({
    equipmentName: "",
    unit: "",
    quantity: "",
  });

  const formikAddEquipment = useFormik({
    initialValues: addEquipment,
    validateOnChange: false,
    validateOnBlur: false,
  });
  const [equipmentCatError, setEquipmentCatError] = useState("");

  const [equipmentProductError, setEquipmentProductError] = useState("");
  const [equipmentUnitError, setEquipmentUnitError] = useState("");
  const [equipmentQuantityError, setEquipmentQuantityError] = useState("");
  const [equipmentError, setEquipmentError] = useState("");

  const handleAddEquipment = () => {
    let hasError = false;
   if (!formikAddEquipment.values.categoryName) {
      setEquipmentCatError("Required");
      hasError = true;
    } else {
      setEquipmentCatError("");
    }
    if (!formikAddEquipment.values.equipmentName) {
      setEquipmentCatError("Required");
      hasError = true;
    } else {
      setEquipmentCatError("");
    }
    if (!formikAddEquipment.values.unit) {
      setEquipmentUnitError("Required");
      hasError = true;
    } else {
      setEquipmentUnitError("");
    }
    if (!formikAddEquipment.values.quantity) {
      setEquipmentQuantityError("Required");
      hasError = true;
    } else {
      setEquipmentQuantityError("");
    }
    if (hasError) return;

    if (
      formikAddEquipment.values.equipmentName &&
      formikAddEquipment.values.quantity
    ) {
      const newItem = {
        equipmentName: formikAddEquipment.values.equipmentName,
        productName:
          sortedProList.find(
            (i) => i.value === formikAddEquipment.values.equipmentName
          )?.label || formikAddEquipment.values.equipmentName,
        quantity: formikAddEquipment.values.quantity,
        unit: formikAddEquipment.values.unit,
        categoryName: formikAddEquipment.values.categoryName,
         categoryName:
          sortedProList.find(
            (i) => i.value === formikAddEquipment.values.categoryName
          )?.label || formikAddEquipment.values.categoryName,
      };
      setEquipItems([...Equipitems, newItem]);
      let updatedItems = Item.filter(
        (it) => it.value !== formikAddEquipment.values.equipmentName
      );
      setData(updatedItems);
      formikAddEquipment.resetForm();
      setAddEquipment({
        equipmentName: "",
        unit: "",
        quantity: "",
      });
      setEquipmentError("");
    }
  };

  const handleQuantityChange = (e, index, section) => {
    const updatedQuantity = e.target.value;
    const updatedItems = Equipitems.map((item, idx) => {
      if (idx === index) {
        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });
    setEquipItems(updatedItems);
  };

  const handleProductUnitChange = (value, index, section) => {
    const updatedItems = Equipitems.map((item, idx) => {
      if (idx === index) {
        return { ...item, unit: value };
      }
      return item;
    });
    setEquipItems(updatedItems);
  };

  const handleDeleteItem = (indexToDelete, section) => {
    const deletedItem = Equipitems[indexToDelete];
    const updatedItems = Equipitems.filter(
      (_, index) => index !== indexToDelete
    );
    setEquipItems(updatedItems);
    if (deletedItem) {
      setData([
        ...Item,
        { value: deletedItem.equipmentName, label: deletedItem.productName },
      ]);
    }
  };

  const handleQuantityChangeExisting = (e, index) => {
  const updatedQuantity = e.target.value;
  const updatedItems = createNew.equipments.map((item, idx) =>
    idx === index ? { ...item, quantity: updatedQuantity } : item
  );
  setCreateNew(prev => ({ ...prev, equipments: updatedItems }));
};

const handleProductUnitChangeExisting = (value, index) => {
  const updatedItems = createNew.equipments.map((item, idx) =>
    idx === index ? { ...item, unit: value } : item
  );
  setCreateNew(prev => ({ ...prev, equipments: updatedItems }));
};

  // const handleProductUnitChange = (value, index, section) => {
  //   const updatedItems = Equipitems.map((item, idx) => {
  //     if (idx === index) {
  //       return { ...item, unit: value };
  //     }
  //     return item;
  //   });
  //   setEquipItems(updatedItems);
  // };


const handleDeleteItemExisting = (indexToDelete) => {
  const deletedItem = createNew.equipments[indexToDelete];
  const updatedItems = createNew.equipments.filter((_, idx) => idx !== indexToDelete);
  setCreateNew(prev => ({ ...prev, equipments: updatedItems }));

  if (deletedItem) {
    setData(prev => [
      ...(Array.isArray(prev) ? prev : []),
      { value: deletedItem.equipmentName, label: deletedItem.productName }
    ]);
  }
};





 useEffect(() => {
    if (createNew?.Equipitems && Equipitems) {
      const mergedArray = [...createNew.Equipitems, ...Equipitems];
      setEquipItems(mergedArray);
    }
  }, [createNew?.Equipitems, Equipitems]);

  useEffect(() => {
    // Filter items not already selected in equipments
    const filteredItems = Item.filter(
      (drop) =>
        !createNew?.Equipitems?.some((eq) => eq.equipmentName === drop.value)
    );
  
    // Merge with oldData (which is previously selected)
    const combined = Array.from(
      new Map([...filteredItems, ...oldData].map((item) => [item.value, item])).values()
    );
  
    // Sort alphabetically
    const sortedData = combined.sort((a, b) => a.label?.localeCompare(b.label));
  
    // Set dropdown options
    setSortedProList(sortedData);
  
    console.log("Filtered Item List:", filteredItems);
  }, [Item, createNew.Equipitems, oldData]);


  useEffect(() => {
    if (Item) {
      const union = Array.from(
        new Map(
          [...Item, ...oldData].map((item) => [item?.value, item])
        ).values()
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label));
      setSortedProList(data);
    }
  }, [Item]);

  useEffect(() => {
    if (formikAddEquipment.values.equipmentName) {
      const findValue = sortedProList.filter(
        (v) => formikAddEquipment.values?.equipmentName == v.value
      );
      setOldData(findValue);
    }
  }, [formikAddEquipment.values.equipmentName]);

  const [showPopupEquipment, setShowPopupEquipment] = useState(false);

  const togglePopupEqupiment = () => {
    setShowPopupEquipment(!showPopupEquipment);
  };

  const handleAssigneeChange = (formId, selectedOptions) => {
    setFormAssignees((prev) =>
      prev.map((form) => {
        if (form.formId === formId) {
          return {
            ...form,
            assignees: selectedOptions.map((option) => option.value),
          };
        }
        return form;
      })
    );
  };

     const [Newcat, setcat] = useState([]);
    const [searcheCat, setSearcheCat] = useState("");
  

  const filteredCategories = Newcat.filter(item =>
  item.label.toLowerCase().includes(searcheCat.toLowerCase())
);

const [Newform, setForm] = useState([]);

function getForm() {
  axiosInstance
    .get(`/survey-category/`)
    .then((res) => {
      if (Array.isArray(res.data.data)) {
        const formatted = res.data.data
          .filter(item => item.enabled) 
          .map(item => ({
            value: item.id,
            label: item.category
          }));
        setForm(formatted);
      } else {
        console.error("Unexpected API response format");
        setForm([]);
      }
    })
    .catch(err => {
      console.error("Error fetching forms:", err);
      setForm([]);
    });
}
 useEffect(() => {
  
getForm()
  }, [])

    const [Newinspector, setInspector] = useState([]);
    
      function getContractsByTeamId() {
        axiosInstance
          .get(`/team/drop-down`)
          .then((res) => {
            if (Array.isArray(res.data)) {
              const formatted = res.data.map(item => ({
                value: item.value,
                label: item.label,
              }));
              setInspector(formatted);
            } else {
              console.error("Unexpected API response format");
              setInspector([]);
            }
          })
          .catch(err => {
            console.error("Error fetching contracts by client ID:", err);
            setInspector([]);
          });
      }
    
      useEffect(() => {
        getContractsByTeamId()
      }, [])

  return (
    <div className=" w-full h-full py-2 px-4  ">
      <div className="flex justify-between w-full mb-2">
        <Breadcrumb
          items={[
            {
              name: "Survey",
              link: "/Contract-management/survey-report",
            },

            { name: "Edit" },
          ]}
        />
        <BackButton />
      </div>
       <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto p-4 bg-white rounded-md">
            <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
         <div className="w-full">
              <SettingHeading title={`Survey : ${createNew?.refNumber}`} />
            </div>
            <FormikSelectTwo
              type="text"
              label="Client "
              placeholder="Client  "
              Options={client}
              formik={formik}
              name="clientId"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              handleClick={togglePopup}
              FixPosition={true}
                      PortalTarget={false}
              setSearch={setSearchClient}
            />
            <NuInput
              type="text"
              label="Project"
              placeholder="Project"
              formik={formik}
              name="project"
              width="w-full md:w-1/3 md:-mt-2"
            />
            {/* <NuInput
              type="text"
              label="Scope"
              placeholder="scope"
              formik={formik}
              name="scope"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}
            {/* <FormikSelectTwo
                             type="text"
                             label="Inspector"
                             placeholder="Inspector"
                             Options={inspector}
                             formik={formik}
                             name="inspector"
                             isRequired={true}
                            width="w-full md:w-1/3 md:-mt-2"
                             
                             handleClick={togglePopup}
                             FixPosition={false}
                             PortalTarget={false}
                             
                             setSearch={setSearchClient}
                           /> */}

            <MultiSelect
              label="Assignee"
              Options={Newinspector}
              formik={formik}
              placeholder="Choose"
              name="assignee"
              // isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="text"
              label="Location"
              placeholder="Location"
              formik={formik}
              name="location"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <NuDate
              label="Inspection Date"
              placeholder="Inspection Date"
              formik={formik}
              name="inspectionDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <FormikSelectTwo
              label="Form"
              Options={Newform}
              formik={formik}
              placeholder="Choose"
              name="form"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
                      PortalTarget={false}
            />

            <DropDownAddMetaData
              type="text"
              label="Status"
              placeholder="Status"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3 md:-mt-3"
              displayProperty={"Status"}
              propertyName={"Status_Survey"}
              getFunc={refStatus}
              FixPosition={true}
                      PortalTarget={false}
            />

            <NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scope"
              width="w-full md:w-1/2 md:-mt-2"
            />
            <div className="w-full">
              <SettingHeading title="Attachment" />

              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full md:w-1/2"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            </div>

            <div className="md:flex justify-between mt-5 px-3 w-full">
              <div className="w-full flex gap-2 items-center flex-wrap">
                {filePathList &&
                  filePathList?.map((imgs, idx) => {
                    console.log("img", imgs);
                    let Ext = imgs?.file_name.split(".").reverse()[0];
                    return (
                      <div
                        className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                        key={idx}
                        style={{
                          border: "1px solid gray",
                          borderColor:
                            "rgb(148 163 184 / var(--tw-bg-opacity))",
                        }}
                      >
                        <div
                          className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                          onClick={() => UpdateAttachmentList(imgs?.file)}
                        >
                          <CloseIcon color="white" height="8" width="8" />
                        </div>
                        <div
                          className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                          onClick={() => handleImageClick(imgs)}
                        >
                          <div className=" w-8 h-8">
                            {videotype.includes(Ext) ? <Video /> : null}

                            {Ext === ("docx" || "doc" || "txt") ? (
                              <Doc />
                            ) : Ext === ("xlsx" || "xls") ? (
                              <Xls />
                            ) : Ext === "txt" ? (
                              <Txt />
                            ) : Ext === "pdf" ? (
                              <Pdf />
                            ) : Ext === "PDF" ? (
                              <Pdf />
                            ) : Ext === "pptx" ? (
                              <>No file</>
                            ) : (
                              <img src={imgs?.file} alt="#" width="120%" />
                            )}
                          </div>
                          <p className=" w-[50px] text-[11px] truncate">
                            {imgs?.file_name}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className=" flex items-center gap-3">
              <p className=" text-xs 2xl:text-sm ">Enable Equipment List</p>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={value?.equipEnabled}
                  onChange={() => handleToggleChange(value.id)}
                  className="sr-only peer"
                />
                <div
                  className={`relative w-11 h-6 rounded-full peer 
                                      ${
                                        value?.equipEnabled
                                          ? "bg-baseColor-primary"
                                          : "bg-gray-300"
                                      }`}
                >
                  <div
                    className={`absolute top-0.5 left-0.5 bg-white border-gray-300 border rounded-full h-5 w-5 transition-all 
                                        ${
                                          value?.equipEnabled
                                            ? "transform translate-x-5"
                                            : ""
                                        }`}
                  ></div>
                </div>
                {/* <span className="ml-2 text-sm font-medium text-gray-900">
                                      {value?.enabled ? 'Enabled' : 'Disabled'}
                                    </span> */}
              </label>
            </div>

            {value?.equipEnabled == true && (
              <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
                <div className="w-full flex justify-between p-2">
                  <div className="w-full px-2">
                    <SettingHeading title="Equipment Detail" />
                  </div>
                  {/* <div className="flex gap-4">
                  <ImportButton
                    label="Import"
                    handleClick={handleImportClick}
                  />
                  <ExportButton
                    label="Export"
                    handleClick={() => setShowExport(true)}
                  />
                </div> */}
                </div>
                <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                
                  <SelectProductWithError
                  type="text"
                  label="Equipment"
                  placeholder="Equipment"
                  Options={Equip}
                  formik={formikAddEquipment}
                  name="equipmentName"
                  width="w-full md:w-1/2 lg:w-2/5 z-9"
                  px="0"
                  // handleClick={togglePopupEqupiment}
                  setSearch={setSearchequipment}
                  FixPosition={true}
                  PortalTarget={false}
                  disabled={false}
                   getFunc={refEquip}
              displayProperty={"Equipment"}
              propertyName={"Contract_Equip"}
                />
                   <SelectProductWithError
                    type="text"
                    label="Category "
                    placeholder="Category "
                    Options={filteredCategories}
                    formik={formikAddEquipment}
                    name="categoryName"
                    width="w-full md:w-1/2 lg:w-2/5 z-10"
                    ErrMessage={equipmentCatError}
                    px="0"
                    handleClick={togglePopupCat}
                    setSearch={setSearcheCat}
                    FixPosition={true}
                    PortalTarget={false}
                  />
              
                  <DropDownAddUnitWithError
                    label="Unit"
                    placeholder="Choose"
                    Options={unit}
                    formik={formikAddEquipment}
                    name="unit"
                    width="w-full md:w-1/2 lg:w-1/5"
                    getFunc={refunit}
                    displayProperty={"Add Unit"}
                    propertyName={"unit_equipments"}
                    ErrMessage={equipmentUnitError}
                    FixPosition={true}
                    PortalTarget={false}
                  />
                  <NuInputWithError
                    label="Quantity"
                    type="number"
                    formik={formikAddEquipment}
                    placeholder="Quantity"
                    name="quantity"
                    width="w-full md:w-1/2 lg:w-1/5"
                    ErrMessage={equipmentQuantityError}
                  />
                  <button
                    onClick={handleAddEquipment}
                    type="button"
                    className="p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-baseColor-primary border border-solid border-white text-xs font-medium text-white rounded-lg"
                  >
                    Add
                  </button>
                </div>
                <div className="w-full bg-white overflow-y-scroll mt-5">
                  {equipmentError && (
                    <p className="text-xs font-semibold text-red-500 px-4">
                      {equipmentError}
                    </p>
                  )}
                  <div className="w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex">
                    <p className="w-[5%] text-left text-white text-xs font-medium">
                      S.No
                    </p>
                    <p className="w-[30%] text-left text-white text-xs font-medium">
                      Equipment
                    </p>
                    <p className="w-[25%] text-left text-white text-xs font-medium">
                      Category
                    </p>
                    
                    <p className="w-[15%] text-center  text-white text-xs font-medium flex justify-center">
                      Unit
                    </p>
                    <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                      Quantity
                    </p>
                    <p className="w-[5%] text-right text-white text-xs font-medium pr-1">
                      Action
                    </p>
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => setIsEquipmentEditable((prev) => !prev)}
                    >
                      <EditIcon
                        width="14"
                        height="14"
                        color={isEquipmentEditable ? "#facc15" : "#ffff"}
                      />
                    </span>
                  </div>


                  <div className="h-[calc(100vh-300px)] overflow-y-scroll hidden md:block">
                  {/* new one */}

                    {Equipitems?.map((List, index) => (
                      <div
                        key={index}
                        className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                      >
                        <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {index + 1}
                        </p>
                        <p className="w-[30%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.productName}
                        </p>
                       <p className="w-[25%] text-left  text-xs font-medium text-[#111537] py-2.5">
                         {List?.categoryName}
                        </p>
                        
                        <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        <Select
  value={unit.find((item) => String(item.value) === String(List?.unit)) || null}
  options={isEquipmentEditable ? unit : []}
                            className="w-11/12 text-center"

  onChange={(value) => handleProductUnitChange(value, index, "equipment")}
  disabled={!isEquipmentEditable}
  placeholder="Select Unit"
  
/>
                        </p>
                        <p className="w-[20%] text-center text-xs font-medium text-[#111537] ">
                          <input
                            type="number"
                            className="w-11/12 py-2.5 mx-auto outline-none text-center border border-gray-300 rounded"
                            value={List?.quantity}
                            disabled={!isEquipmentEditable}
                            onChange={(e) =>
                              handleQuantityChange(e, index, "equipment")
                            }
                          />
                        </p>
                        <div className="w-[5%] text-right py-2.5">
                          <button
                            onClick={() => {
    setDeleteInfo({ index, type: "equipment", isExisting: false });
    setIsDeletePopupOpen(true);
  }}
                            type="button"
  disabled={!isEquipmentEditable}

                            className="text-red-500 cursor-pointer ml-4 border-none"
                          >
                            <DeleteIcon color="red" height={12} />
                          </button>
                        </div>
                      </div>
                    ))}

                    {/* Already existing */}
                                      {createNew?.equipments?.map((List, index) => (
                                        <div
                                          key={index}
                                          className="w-full odd:bg-white even:bg-gray-100"
                                        >
                                          <div className="w-full py-2 flex items-center justify-between px-6">
                                            <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">
                                              {index + 1 + Equipitems.length}
                                            </p>
                                             <p className="w-[30%] text-left text-xs font-medium text-[#111537] py-2.5">
                          {List?.name}
                        </p>
                                           <p className="w-[25%] text-left  text-xs font-medium text-[#111537] py-2.5">
                         {List?.categoryName}
                        </p>
                        
                        <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                          <Select
  value={unit.find((item) => item?.value === List?.unit) || null}
  options={isEquipmentEditable ? unit : []}
  onChange={(value) =>
    handleProductUnitChangeExisting(value, index)
  }
  disabled={!isEquipmentEditable}
                            className="w-11/12 text-center"

/>
                        </p>
                        <p className="w-[20%] text-center text-xs font-medium text-[#111537] ">
                          <input
  type="number"
  className="w-11/12 py-2.5 mx-auto outline-none text-center border border-gray-300 rounded"
  value={List?.quantity}
  disabled={!isEquipmentEditable}
  onChange={(e) =>
    handleQuantityChangeExisting(e, index)
  }
/>
                        </p>
                                                                   <div className="w-[5%] text-right py-2.5">
                                            <button
  onClick={() => {
    setDeleteInfo({ index, type: "equipment", isExisting: true });
    setIsDeletePopupOpen(true);
  }}
  type="button"
  disabled={!isEquipmentEditable}

  className="text-red-500 cursor-pointer ml-4 border-none"
>
  <DeleteIcon color="red" height={12} />
</button>
                                            </div>
                                          </div>
                    
                                        
                                        </div>
                                      ))}
                  </div>

                  {/* mobile */}
                <div className="md:hidden px-4 space-y-4 mt-4">
  {[...Equipitems, ...(createNew?.equipments || [])].map((item, index) => {
    const isExisting = index >= Equipitems.length;
    const adjustedIndex = isExisting ? index - Equipitems.length : index;

    return (
      <div key={index} className="p-3 border rounded shadow-sm space-y-2 bg-gray-50">
           <div className="text-right">
          <button
            onClick={() => {
    setDeleteInfo({ index: adjustedIndex, type: "equipment", isExisting });
    setIsDeletePopupOpen(true);
  }}
            type="button"

            className="text-red-500 text-xs"
          >
            <DeleteIcon color="red" height={12} />
          </button>
        </div>
        <div className="text-xs font-medium text-[#111537]">S.No: {index + 1}</div>
        <div className="text-xs font-medium text-[#111537]">
          Equipment: {item?.productName?.label || item?.productName || item?.name}
        </div>
<div>
                          <span className="text-xs font-medium text-[#111537]">
                            Category:
                          </span>{" "}
                          {item?.categoryname}
                        </div>
        <div className="flex justify-between items-center text-xs font-medium text-[#111537]">
          <span>Unit:</span>
          <span
            className="cursor-pointer"
            onClick={() => setIsEquipmentEditable((prev) => !prev)}
          >
            <EditIcon
              width="14"
              height="14"
              color={isEquipmentEditable ? "#facc15" : "#9ca3af"}
            />
          </span>
        </div>
        <Select
          value={unit.find((u) => u?.value === item?.unit) || null}
          options={isEquipmentEditable ? unit : []}
          onChange={(value) => {
            if (isExisting) {
              handleProductUnitChangeExisting(value, adjustedIndex);
            } else {
              handleProductUnitChange(value, adjustedIndex, "equipment");
            }
          }}
          disabled={!isEquipmentEditable}
          className="w-full"
        />

        <div className="flex justify-between items-center pt-2 text-xs font-medium text-[#111537]">
          <span>Quantity:</span>
          <span
            className="cursor-pointer"
            onClick={() => setIsEquipmentEditable((prev) => !prev)}
          >
            <EditIcon
              width="14"
              height="14"
              color={isEquipmentEditable ? "#facc15" : "#9ca3af"}
            />
          </span>
        </div>
        <input
          type="number"
          className="w-full border px-2 py-1 rounded text-xs"
          value={item?.quantity}
          disabled={!isEquipmentEditable}
          onChange={(e) => {
            if (isExisting) {
              handleQuantityChangeExisting(e, adjustedIndex);
            } else {
              handleQuantityChange(e, adjustedIndex, "equipment");
            }
          }}
        />

     
      </div>
    );
  })}
</div>

                </div>
              </div>
            )}

            {/* <div className="w-full h-full flex flex-wrap mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Form :
                </p>
              </div>

              <div className="w-full py-3 bg-baseColor-primary rounded-lg px-6 hidden md:flex ">
                <p className="w-[5%] text-left text-white text-xs font-medium">
                  S.No
                </p>
                <p className="w-[55%] text-left text-white text-xs font-medium">
                  Form
                </p>
                <p className="w-[40%] text-center text-white text-xs font-medium">
                  Assignees
                </p>
              </div>

              <div className="h-[calc(100vh-300px)] overflow-y-auto w-full">
                {data?.forms?.length > 0 ? (
                  data.forms.map((item, idx) => (
                    <div
                      key={item.formId}
                      className="w-full py-4 px-4 sm:px-6 border sm:flex sm:justify-between sm:items-center odd:bg-white even:bg-slate-50"
                    >
                      <p className="md:w-[5%] w-auto text-left text-xs font-medium text-[#111537]">
                        {idx + 1}
                      </p>

                      <p className="md:w-[55%] w-auto text-left text-xs font-medium text-[#111537]">
                        {item.formName}
                      </p>

                      <div className="md:w-[40%] w-auto text-left text-xs font-medium text-[#111537]">
                        <MultiSelectinp
                          label="Assignee"
                          Options={Newinspector}
                          value={
                            formAssignees
                              .find((f) => f.formId === item.formId)
                              ?.assignees?.map((assignee) => ({
                                value: assignee,
                                label:
                                  Newinspector.find((i) => i.value === assignee)
                                    ?.label || assignee,
                              })) || []
                          }
                          onChange={(selectedOptions) =>
                            handleAssigneeChange(item.formId, selectedOptions)
                          }
                          placeholder="Choose"
                          width="w-full"
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-xs text-gray-500 p-6">
                    No forms available.
                  </p>
                )}
              </div>
            </div> */}

            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
        
      </form>
    </div>

    {isDeletePopupOpen && (
 <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure you want to delete this?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setIsDeletePopupOpen(false)}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
              >
                No
              </button>
              <button
                onClick={() => {
            if (deleteInfo) {
              if (deleteInfo.isExisting) {
                handleDeleteItemExisting(deleteInfo.index);
              } else {
                handleDeleteItem(deleteInfo.index, deleteInfo.type);
              }
            }
            setIsDeletePopupOpen(false);
          }}
                className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
)}

    </div>
  );
}

export default EditSurveyReport;
